import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import React, {Fragment} from "react";
import {s_char} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char_attr_step_cc, s_char_attr_sum} from "../../_signals/s_char_attr";
import CharCreate from "../../_helper/charcreate";
import {attributeRaiseChanges} from "../../_helper/attributeRaiseChanges";
import {v4} from "uuid";
import updChar from "../../_sig_api/updChar";

type Props = {
    attribute: string;
};

export default function AttributeCreation({attribute}: Props) {
    useSignals();

    const handleValueChange = (change) => {
        if (!s_char.value.race) {
            alert('Keine Rasse ausgewählt');
            return;
        }
        let current = s_char.value[attribute+'_c'];
        if ((current >= 8 && change) || (current <= -2 && !change)) return;
        if (change) current++; else current--;
        updChar([{k:attribute+'_c',v: current}])
    }

    let label = CharCreate.attributes.find(a => a.pfield === attribute)?.title || attribute;
    let attr_sum = s_char_attr_sum(attribute).value;

    const diffs = attributeRaiseChanges(attribute, attr_sum, attr_sum + 3);

    return <Grid container spacing={2}>
        <Grid item xs={6}>
            <div>{label + ' Wert ' + attr_sum}</div>
            <Button onClick={() => handleValueChange(true)}>+</Button>
            <Button onClick={() => handleValueChange(false)}>-</Button>
        </Grid>
        <Grid item xs={6} style={{textAlign: 'left'}}>
            <div>{'Verteilt: ' + s_char.value[attribute+'_c']}</div>
            <div>{'Stufe: ' + s_char_attr_step_cc(attribute)}</div>
            {diffs.length > 0 ? <div>
                Änderungen:
                {diffs.map((d) => <div key={v4()}>
                    <b>Wert: {d.v}</b> {d.c.length===0?'keine':<Fragment>{d.c.map(c=><div key={v4()}> - {c}</div>)}</Fragment>}
                </div>)}
            </div> : null}
        </Grid>
    </Grid>

}